import { render, staticRenderFns } from "./AssetDepreciation.vue?vue&type=template&id=4ce4e010&scoped=true&"
import script from "./AssetDepreciation.vue?vue&type=script&lang=ts&"
export * from "./AssetDepreciation.vue?vue&type=script&lang=ts&"
import style0 from "./AssetDepreciation.vue?vue&type=style&index=0&id=4ce4e010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4e010",
  null
  
)

export default component.exports